import {
    ManufacturerProductPropertyDetail,
    ManufacturerProductPropertyOptionDetail,
    ManufacturerProductPropertyOptionGroupDetail,
} from '@deltek/specification-client/core/Models/product'

import { PropertiesType } from '../../../ListingDetailsPage'

type DuplicateCheckerProps = {
    property: string | Record<string, string | boolean>
    properties?: PropertiesType
    premiumOptions: Array<Partial<ManufacturerProductPropertyOptionDetail>>
    propertyName?: string
    subPropertyName?: string
    isMasterSpec?: boolean
}

export const checkForDuplicates = ({
    property,
    properties,
    premiumOptions,
    propertyName,
    subPropertyName,
    isMasterSpec,
}: DuplicateCheckerProps) => {
    const optionType = typeof property
    const optionValue: string =
        optionType === 'string'
            ? (property as string)
            : `${(property as Record<string, string>).imperialUnits} (${
                  (property as Record<string, string>).metricUnits
              })`

    let hasDuplicate = false

    if (isMasterSpec && properties && propertyName) {
        hasDuplicate = !!properties[propertyName][
            properties[propertyName].findIndex(
                (item: Partial<ManufacturerProductPropertyDetail>) =>
                    item.subPropertyName === subPropertyName
            )
        ].optionGroups?.find(
            (group: Partial<ManufacturerProductPropertyOptionGroupDetail>) =>
                !!group.options?.find(
                    (
                        option: Partial<ManufacturerProductPropertyOptionDetail>
                    ) =>
                        option.value?.toLowerCase() ===
                            optionValue.toLowerCase() && !option.isPremiumPlus
                )
        )
    }

    return (
        hasDuplicate ||
        //check if there are duplicates on manufacturer options
        premiumOptions.some(
            ({
                value,
                isUnitOfMeasure,
            }: Partial<ManufacturerProductPropertyOptionDetail>) =>
                (value?.toLowerCase() === optionValue.toLowerCase() &&
                    !!isUnitOfMeasure &&
                    optionType !== 'string') ||
                (value?.toLowerCase() === optionValue.toLowerCase() &&
                    optionType === 'string')
        )
    )
}
